// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2QP3R","container":"styles_container__V5JUD","title":"styles_title__1ySiD","wrapper":"styles_wrapper__D1wCq","answer":"styles_answer__2BLTv"};